export const featurePages = [
  {
    href: '/process',
    title: 'Adoption Experience',
    summary: 'Map out how we listen, curate, and craft every placement from first hello through homecoming.',
    icon: '🗺️',
    accent: 'from-rose-100 via-white to-white'
  },
  {
    href: '/kittens',
    title: 'Available Kittens',
    summary: 'Preview current litters, temperament notes, and upcoming nursery debuts before they go public.',
    icon: '✨',
    accent: 'from-sky-100 via-white to-white'
  },
  {
    href: '/about',
    title: 'Our Cattery',
    summary: 'Step inside our maison, meet the queens and studs, and explore the rituals that shape every kitten.',
    icon: '🏡',
    accent: 'from-emerald-100 via-white to-white'
  },
];
